module.exports = __webpack_public_path__ + "img/money-check-dollar.7699e204.svg";